//统一管理项目前部的接口
import requests from "./requests";

export const reqTypeNavList = () => {
    return requests({ method: 'get', url: '/column/navBar/homepage/getVisibleNavBar' });
}

//获取首页轮播图数据的接口 简写方式
export const reqBannerList = () => requests({ url: '/slideShow/slideShowAdmin/homepage/getDisSlideshow', method: 'get' });
//获取Floor友情链接数据接口
export const reqFloorList = () => requests({ url: '/links/eduLinkAdmin/homepage/getVisibleLinks', method: 'get' });
//获取home首页通知公告数据接口
export const reqHomeNoticeList = () => requests({ url: '/article/content/homepage/getNotificationPage?pageNum=1&pageSize=4', method: 'get' });
//获取home首页最新发布数据接口
export const reqHomeNewsList = () => requests({ url: '/article/content/homepage/getLatestArticle', method: 'get' });
//获取分类页数据接口
export const reqNoticeNavList = (id) => requests({ url: `/column/subSection/homepage/getVisibleSubSection?primaryColId=${id}`, method: 'get' });
//获取搜索结果接口
export const reqSearchList = (data) => requests({ url: '/article/articleSearch/homepage/search', method: 'post', data });
//获取通知公告子栏文章页
// export const reqNoticeList = (pageNum,pageSize,secondaryColId)=>requests({url:`/article/content/homepage/getArticlePagePublishedBySecondaryColId?pageNum=${pageNum}&pageSize=${pageSize}&secondaryColId=${secondaryColId}`,method:'get'})
export const reqNoticeList = (params) => requests({ url: '/article/content/homepage/getArticlePagePublishedBySecondaryColId', method: 'get', params })
//获取文章详情页数据接口
export const reqDetail = (id) => requests({ url: `/article/content/homepage/getArticlePublished?id=${id}`, method: 'get' });
